export default "__VITE_ASSET__JgIjBaOm__"